import React, {useState} from 'react';
import b_ from 'b_';

import {SurveysGoal} from 'client/common/types';
import {Button} from 'client/common/components/lego';
import {sendGoal} from 'client/common/utils/metrika';
import I18N from 'assets/i18n/brandlift-project';

import {LaunchButtonsProps} from './types';

import './publication.css';

const i18n = I18N.common.publication;
const b = b_.with('publication');

// eslint-disable-next-line max-statements
export function LaunchButtons(props: LaunchButtonsProps) {
    const {
        disabled,
        isSuperuser,
        isWalletUsed,
        isPackageUsed,
        needToPay,
        canPayAsIndividual,
        onClose,
        onPayAsEntity,
        onPayAsIndividual,
        onPayWithWallet,
        onPayWithPackage,
        onPublishRevision,
        launchBtnText = i18n.launchSurvey,
        payAsEntityBtnText = i18n.payAsEntity,
        payBtnText = i18n.pay
    } = props;

    const [isPending, setIsPending] = useState(false);

    const handleLaunch = async (onPay?: () => Promise<void>) => {
        setIsPending(true);

        await onPublishRevision();

        if (onPay) {
            sendGoal(SurveysGoal.MakePayment);
            await onPay();
        }

        setIsPending(false);

        onClose();
    };

    if (!needToPay || isSuperuser || isPackageUsed) {
        const handleClick = async () =>
            handleLaunch(async () => {
                if (isPackageUsed) {
                    await onPayWithPackage();
                }
            });

        return (
            <div className={b('launch-buttons')}>
                <Button
                    className={b('button')}
                    disabled={disabled}
                    onClick={handleClick}
                    progress={isPending}
                    size='m'
                    width='max'
                    view='dl-action'
                >
                    {launchBtnText}
                </Button>
            </div>
        );
    }

    if (isWalletUsed) {
        const handleClick = async () => {
            sendGoal(SurveysGoal.ClickPayWithWallet);

            await handleLaunch(async () => {
                await onPayWithWallet();
            });
        };

        return (
            <div className={b('launch-buttons')}>
                <Button
                    className={b('button')}
                    disabled={disabled}
                    onClick={handleClick}
                    progress={isPending}
                    size='m'
                    width='max'
                    view='dl-action'
                >
                    {payBtnText}
                </Button>
            </div>
        );
    }

    const handleClickEntityButton = async () => {
        sendGoal(SurveysGoal.ClickPay);

        await handleLaunch(async () => {
            await onPayAsEntity();
        });
    };

    const handleClickIndividualButton = async () => {
        sendGoal(SurveysGoal.ClickPayPerson);

        // eslint-disable-next-line @typescript-eslint/require-await
        await handleLaunch(async () => {
            onPayAsIndividual();
        });
    };

    if (!canPayAsIndividual) {
        return (
            <div className={b('launch-buttons')}>
                <Button
                    className={b('button')}
                    disabled={disabled}
                    onClick={handleClickEntityButton}
                    progress={isPending}
                    size='m'
                    width='max'
                    view='dl-action'
                >
                    {payBtnText}
                </Button>
            </div>
        );
    }

    return (
        <div className={b('launch-buttons')}>
            <Button
                className={b('button')}
                disabled={disabled}
                onClick={handleClickEntityButton}
                progress={isPending}
                size='m'
                width='max'
                view='dl-default'
            >
                {payAsEntityBtnText}
            </Button>
            <Button
                className={b('button')}
                disabled={disabled}
                onClick={handleClickIndividualButton}
                progress={isPending}
                size='m'
                width='max'
                view='dl-action'
            >
                {payBtnText}
            </Button>
        </div>
    );
}
